import { roles } from 'cassandra-shared-js/roles';
import permissions from './permissions';
import actions from './actions';

const createActionsPerRole = (role) => {
  const initialAcc = Object.keys(actions).reduce((acc, action) => {
    acc[action] = false;
    return acc;
  }, {});

  return permissions.reduce((acc, permission) => {
    const { roles: permissionRoles, action } = permission;
    acc[action] = acc[action] || permissionRoles.includes(roles[role]);
    return acc;
  }, initialAcc);
};

// actionsForAllRoles[role][action] = true / false
const actionsForAllRoles = Object.keys(roles).reduce((acc, role) => {
  acc[role] = createActionsPerRole(role);
  return acc;
}, {});

export const hasPermission = (role) => {
  return (action) => {
    if (!role || !action) {
      return false;
    }
    const actionsForRole = actionsForAllRoles[role];
    if (!actionsForRole) {
      return false;
    }
    return actionsForRole[action];
  };
};
